module.exports = __webpack_public_path__ + "static/img/アセット 37@2x.b22c0e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 37@2x.png
// module id = hdVG
// module chunks = 1